/**
 * @generated SignedSource<<379b43f9ef1109c14a848638b4612099>>
 * @relayHash 614d396c8e6ecec858e588739a73cf6b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 13d9e6a9b9b423343dfe5d66aeff60a66cd46a6e0bd034b8102b368d14081e5c

import type { ConcreteRequest, Query } from 'relay-runtime';
export type WhiteboardCreationPaywallDialogWhiteboardCreationPaywallContentToDisableQuery$variables = Record<PropertyKey, never>;
export type WhiteboardCreationPaywallDialogWhiteboardCreationPaywallContentToDisableQuery$data = {
  readonly paywallContentToDisable: {
    readonly deactivationIdentifier: string;
    readonly link: string | null | undefined;
    readonly title: string | null | undefined;
  } | null | undefined;
};
export type WhiteboardCreationPaywallDialogWhiteboardCreationPaywallContentToDisableQuery = {
  response: WhiteboardCreationPaywallDialogWhiteboardCreationPaywallContentToDisableQuery$data;
  variables: WhiteboardCreationPaywallDialogWhiteboardCreationPaywallContentToDisableQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "args": [
      {
        "kind": "Literal",
        "name": "contentType",
        "value": "whiteboard"
      }
    ],
    "concreteType": "PaywallContentSingle",
    "kind": "LinkedField",
    "name": "paywallContentToDisable",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "deactivationIdentifier"
      },
      {
        "kind": "ScalarField",
        "name": "link"
      },
      {
        "kind": "ScalarField",
        "name": "title"
      }
    ],
    "storageKey": "paywallContentToDisable(contentType:\"whiteboard\")"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "WhiteboardCreationPaywallDialogWhiteboardCreationPaywallContentToDisableQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "WhiteboardCreationPaywallDialogWhiteboardCreationPaywallContentToDisableQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "614d396c8e6ecec858e588739a73cf6b",
    "id": "13d9e6a9b9b423343dfe5d66aeff60a66cd46a6e0bd034b8102b368d14081e5c",
    "metadata": {},
    "name": "WhiteboardCreationPaywallDialogWhiteboardCreationPaywallContentToDisableQuery",
    "operationKind": "query",
    "text": "query WhiteboardCreationPaywallDialogWhiteboardCreationPaywallContentToDisableQuery{paywallContentToDisable(contentType:\"whiteboard\"){deactivationIdentifier,link,title}}"
  }
};
})();

(node as any).hash = "0113a00e3f9a0d6c607ac3e96cb84758";

export default node;
